import { render, staticRenderFns } from "./UiTableReportCommon.vue?vue&type=template&id=eb64d28e&scoped=true"
import script from "./UiTableReportCommon.vue?vue&type=script&lang=js"
export * from "./UiTableReportCommon.vue?vue&type=script&lang=js"
import style0 from "./UiTableReportCommon.vue?vue&type=style&index=0&id=eb64d28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb64d28e",
  null
  
)

export default component.exports